import styled from "styled-components";
import { createLink } from "@tanstack/react-router";

import { useTranslations } from "@/queries/useTranslations";
import { useFilteredIds } from "@/hooks/useFilteredIds";

interface IProps {
    version: string;
}

const StyledAnchor = styled.a`
    border: 1px solid grey;
    padding: 0.5rem;
    margin: 1rem 0;
    border-radius: 0.5rem;
    font-size: 1.2rem;
    color: black;
    text-decoration: none;
    &:hover,
    &:focus,
    &:active,
    &:visited {
        color: black;
    }
    &.active {
        font-weight: bold;
    }
`;
const StyledLink = createLink(StyledAnchor);

const Nav = styled.nav`
    display: flex;
    gap: 0.5rem;
`;

function NavBar({ version }: IProps) {
    const { data: translations } = useTranslations(version);
    const { filtered } = useFilteredIds(version);
    const textCount = filtered?.texts.length ?? translations?.texts.ids.length ?? 0;
    const docCount = filtered?.docs.length ?? translations?.docs.ids.length ?? 0;
    const defaultCount = filtered?.defaultContent.length ?? translations?.defaultContent.ids.length ?? 0;
    return (
        <Nav>
            <StyledLink
                to="/$version/texts"
                params={{ version }}
                search={(prev) => ({ ...prev, page: undefined })}
                activeOptions={{ exact: false, includeSearch: false }}
                activeProps={{ className: "active" }}
            >
                Texts ({textCount})
            </StyledLink>
            <StyledLink
                to="/$version/docs"
                params={{ version }}
                search={(prev) => ({ ...prev, page: undefined })}
                activeOptions={{ exact: false, includeSearch: false }}
                activeProps={{ className: "active" }}
            >
                Docs ({docCount})
            </StyledLink>
            <StyledLink
                to="/$version/default-content"
                params={{ version }}
                search={(prev) => ({ ...prev, page: undefined })}
                activeOptions={{ exact: false, includeSearch: false }}
                activeProps={{ className: "active" }}
            >
                Default content ({defaultCount})
            </StyledLink>
        </Nav>
    );
}

export default NavBar;
